"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useService = exports.useMachine = void 0;
var tslib_1 = require("tslib");
var store_1 = require("svelte/store");
var xstate_1 = require("xstate");
function useMachine(machine, options) {
    if (options === void 0) { options = {}; }
    var context = options.context, guards = options.guards, actions = options.actions, activities = options.activities, services = options.services, delays = options.delays, rehydratedState = options.state, interpreterOptions = tslib_1.__rest(options, ["context", "guards", "actions", "activities", "services", "delays", "state"]);
    var machineConfig = {
        context: context,
        guards: guards,
        actions: actions,
        activities: activities,
        services: services,
        delays: delays
    };
    var createdMachine = machine.withConfig(machineConfig, tslib_1.__assign(tslib_1.__assign({}, machine.context), context));
    var service = xstate_1.interpret(createdMachine, interpreterOptions).start(rehydratedState ? xstate_1.State.create(rehydratedState) : undefined);
    var state = store_1.readable(service.state, function (setState) {
        service.onTransition(function (currentState) {
            if (currentState.changed) {
                setState(currentState);
            }
        });
        return function () {
            service.stop();
        };
    });
    return { state: state, send: service.send, service: service };
}
exports.useMachine = useMachine;
function useService(service) {
    var state = store_1.readable(service.state, function (setState) {
        var unsubscribe = service.subscribe(function (currentState) {
            if (currentState.changed !== false) {
                setState(currentState);
            }
        }).unsubscribe;
        return function () { return unsubscribe(); };
    });
    return { state: state, send: service.send, service: service };
}
exports.useService = useService;
